import { setElementOnClick } from '../ui_utils/DomUtils.ts';
import { UIScrollController } from './UIScrollController.ts';
export class UISingletonScrollController extends UIScrollController {
    constructor(containerId){
        const container = containerId ? document.getElementById(containerId) : document;
        const contentDiv = container.querySelector('.content_singleton_page');
        const sidebarDiv = container.querySelector('.singleton_page_sidebar');
        var _contentDiv_closest;
        const viewportDiv = (_contentDiv_closest = contentDiv.closest('.web-layout-content')) !== null && _contentDiv_closest !== void 0 ? _contentDiv_closest : contentDiv;
        super(contentDiv, sidebarDiv, viewportDiv);
        viewportDiv.addEventListener('scroll', ()=>this.onContentScroll());
        setElementOnClick(sidebarDiv, (event)=>this.onSidebarClick(event));
    }
}
